<template>
  <div v-if="internalValue" class="datagrid-sort-group" :class="{'active': selection}">
    <div @click="setOrder(item.value)">
      <div class="datagrid-sort-label">{{ label ? label : "Tri multiple" }}</div>
      <div class="datagrid-sort-current-value">
        <span v-if="selection && label.toLowerCase() != selection.name.toLowerCase()">{{ selection.name }}</span>
        <i rel="asc" v-if="selection && internalValue.order == 'asc'">↓</i>
        <i rel="desc" v-if="selection && internalValue.order == 'desc'">↑</i>
        <i v-if="selection == null">↕</i>
      </div>
    </div>
    <div class="datagrid-sort-dropdown">
      <div v-for="item in data" :data-sort="item.value">
        <div @click="setOrder(item, 'asc')" :class="['datagrid-sort', {'active': internalValue.sort == item.value && internalValue.order == 'asc'}]">
          <span>{{ label.toLowerCase() == item.name.toLowerCase() ? 'Tri ascendant' : item.name }}</span>
          <i rel="asc">↓</i>
        </div>
        <div @click="setOrder(item, 'desc')" :class="['datagrid-sort', {'active': internalValue.sort == item.value && internalValue.order == 'desc'}]">
          <span>{{ label.toLowerCase() == item.name.toLowerCase() ? 'Tri descendant' : item.name }}</span>
          <i rel="desc">↑</i>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
    export default {
        name: 'DatagridSort',
        props: ['value', 'data'],
        data: function () {
            return {
              internalValue: null,
              selection: null,
              label: ""
            }
        },
      mounted: function()
      {
        this.internalValue = this.value;
        this.updateListing();
      },
      methods: {
        setOrder: function(item, sorting)
        {
          this.$parent.setOrder(item, sorting);
        },
        updateListing: function(){
          this.label = [];
          for(var item in this.data)
          {
            if( this.data[item].name )
            {
              this.label.push(this.data[item].name)
            }
          }
          this.label = this.label.join(" | ");
          for(var item in this.data)
          {
            //console.log("updateListing", this.data[item].value, this.internalValue.sort, this.internalValue.order)
            if( this.internalValue.sort == this.data[item].value ){
              //console.log("ok")
              this.selection = this.data[item];
              return true;
            }
          }
          this.selection = null;
        }
      },
      watch: {
        value: {
          handler: function(newVal, oldVal) {
            this.internalValue = newVal
            this.updateListing()
          },
          deep: true
        }
      }
    }
</script>



// WEBPACK FOOTER //
// src/components/DatagridSort.vue